import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
// import HeaderDashboard from "../../part/header.dashaboard";
import FooterDashboard from "../../part/footer.dashboard";
import TutorDashMenu from "../../part/tutor_dash_menu";
import TutorSearchContent from "../../part/tutor.search.content";
import DashSearchHeader from "../../part/header.search.dashboard";



const TutorSearchParams = () => {
    const getInitialMenuCoverWidth = () => {
        const windowWidth = window.innerWidth;
        if (windowWidth < 900) {
            return 0;
        } else if (windowWidth >= 900 && windowWidth < 1200) {
            return 60;
        } else {
            return 260;
        }
    };
    const [menuCoverWidth, setMenuCoverWidth] = useState(getInitialMenuCoverWidth());
    const { prompt } = useParams();
    const navigate = useNavigate(); // Initialize useNavigate


    const handleResize = useCallback(() => {
        const menuCover = document.querySelector('.dashboard .menu_cover');
        if (menuCover) {
            setMenuCoverWidth(menuCover.offsetWidth);
        }
    }, []);



    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);

        };
    }, [handleResize]);
    
    const handleSearch = (newPrompt) => {  // Function to update search term
        navigate(`/dash_tutor_search/${newPrompt}`); // Navigate to the new search URL
    };

    return (
        <div className="body">
            <DashSearchHeader onResize={handleResize}  onSearch={handleSearch} search={prompt} />
            <TutorDashMenu />
            <div className="dash_body" style={{ width: `calc(100% - ${menuCoverWidth}px - 8px)`, overflow:"hidden" }} >
                <TutorSearchContent search={prompt}/>
                <FooterDashboard />
            </div>
        </div>
    );
};

export default TutorSearchParams;